var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCategoryIndustry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 36925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 91",
    d: "M0.477051 9.11353L9.06796 10.5453",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 92",
    d: "M11.9323 10.5451L20.5232 9.59058",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4012",
    x: 0.5,
    y: 3.40942,
    width: 20,
    height: 14.2727,
    rx: 2.5,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4013",
    d: "M6.18231 2.90909V3.40909H6.68231H14.3187H14.8187V2.90909C14.8187 1.57859 13.7401 0.5 12.4096 0.5H8.5914C7.2609 0.5 6.18231 1.57859 6.18231 2.90909Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4014",
    x: 9.09064,
    y: 9.13647,
    width: 2.81818,
    height: 2.81818,
    rx: 0.5,
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCategoryIndustry);
export default __webpack_public_path__ + "static/media/project-category-industry.3840b2e7.svg";
export { ForwardRef as ReactComponent };